(function() {
  'use strict';

  angular.module('eclipseApp.myAccount').factory('wirelessDashboardService', wirelessDashboardService);

  wirelessDashboardService.$inject = [
    '$http',
    '$rootScope',
    '$q',
    '$window',
    '$translate',
    'env',
    'commonService',
    'uteLocale',
    'uteEndpoint',
    'uteModal',
    'pricePlanInitiation',
    'ute.datalayer.common.service'
  ];

  /* @ngInject */
  function wirelessDashboardService(
    $http,
    $rootScope,
    $q,
    $window,
    $translate,
    env,
    commonService,
    uteLocale,
    uteEndpoint,
    uteModal,
    pricePlanInitiation,
    uteDataLayerService
  ) {
    var API_URL = {
      DEVICE: uteEndpoint('v1/postpaid/dashboard/device'),
      ADD_ON: uteEndpoint('v1/postpaid/dashboard/addOn'),
      DATA_USAGE_DETAILS: env.genesisApiURL + 'uep/v2/dataUsageDetails',
      // DATA_USAGE_DETAILS: 'https://www.local.fido.ca:4200/pages/web/genesis/api/uep/v1/dataUsageDetails',
      PLAN_DETAILS: uteEndpoint('v1/postpaid/dashboard/atgcurrentplandetails'),
      SPOTIFY_PROMO_CODE: env.genesisApiURL + 'spotify-svc/promocode',
      RLH_NOTIFICATION_DETAILS: uteEndpoint('v1/wireless/rlh/getnotificationdetail')
    };

    var x_session_token = $window.localStorage.getItem('x_session_token');
    var janrainCaptureProfileData = $window.localStorage.getItem('easyLoginDataJanrain');
    var profileId = janrainCaptureProfileData !== null ? janrainCaptureProfileData.uuid : '';
    var userId = janrainCaptureProfileData !== null ? JSON.parse(janrainCaptureProfileData).userID : '';

    var myPlanBoxHeightDeferred = $q.defer();
    var myPlanBoxHeightPromise = myPlanBoxHeightDeferred.promise;

    function getDevice(ban, ctn) {
      return $http({
        method: 'POST',
        url: API_URL.DEVICE,
        data: {
          ctn: ctn,
          accountNumber: ban
        }
      });
    }

    function getAddon(ban, ctn) {
      return $http({
        method: 'POST',
        url: API_URL.ADD_ON,
        data: {
          ctn: ctn,
          accountNumber: ban
        }
      });
    }

    function getDataUsageDetails(ban, ctn) {
      return $http({
        method: 'POST',
        url: API_URL.DATA_USAGE_DETAILS,
        withCredentials: false,
        headers: {
          'x-session-token': x_session_token,
          'x-app-id': 'Fido',
          userId: userId,
          profileId: profileId
        },
        data: {
          ctn: ctn,
          accountNumber: ban,
          language: uteLocale.language,
          region: uteLocale.province
        }
      });
    }

    function getPlanDetails(ban, ctn, billingProvince, refreshState) {
      return $http({
        method: 'POST',
        url: API_URL.PLAN_DETAILS,
        data: {
          ctn: ctn,
          accountNumber: ban,
          province: billingProvince,
          expired: refreshState
        }
      });
    }

    function getSpotifyPromoCode(ban, ctn, planTitle) {
      return $http({
        method: 'POST',
        url: API_URL.SPOTIFY_PROMO_CODE,
        headers: {
          'x-session-token': x_session_token,
          'Content-Type': 'application/json',
          brand: 'fido'
        },
        data: JSON.stringify({
          ctn: ctn,
          ban: ban,
          plan: planTitle
        })
      });
    }

    function getRlhNotification(ban, ctn) {
      return $http({
        method: 'POST',
        url: API_URL.RLH_NOTIFICATION_DETAILS,
        data: {
          ctn: ctn,
          accountNumber: ban,
          lang: uteLocale.language
        }
      });
    }

    function initPPC(ban, ctn, fromRealtimeDashboard) {
      return pricePlanInitiation.checkEligibility('ppc', ctn, ban).then(function(response) {
        if (response.data && response.data.eligible === false) {
          $window._satellite.setVar('error', 'PPC | PPC eligibilty error');
          $window._satellite.track('bfa-ppc-error');
          if (response.data && response.data.eligibilityCode === 'SUB_PENDING_PPC_ORDER') {
            var payload = uteDataLayerService.getConfigByMappingKey({
              mappingKey: 'advance.mappingKey.error.ppc-pending-error'
            });
            var api = response.config.url;
            var errorType = $window.ute.datalayer.common.service.ErrorType;
            var errorCategory = $window.ute.datalayer.common.service.ErrorCategory;
            var errorMessage = $translate.instant('ppc_pending_desc');
            var dataLayerPredefinedSection = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
            var globalObjects = [
              dataLayerPredefinedSection.ACCOUNT,
              dataLayerPredefinedSection.PAGE,
              dataLayerPredefinedSection.SITE,
              dataLayerPredefinedSection.GLOBAL
            ];
            uteDataLayerService.trackError(
              payload,
              errorType.USER,
              response.data.status,
              errorMessage,
              errorCategory.SELF_SERVE,
              '',
              api,
              true,
              globalObjects
            );
            ppcErrorMessageWindow();
          } else eligibilityMessageWindow(response.data.eligibilityCode);
        } else {
          pricePlanInitiation.eligibilityProcessing(response.data).then(function() {
            var analyticsId = '';
            if (fromRealtimeDashboard && fromRealtimeDashboard === true) {
              analyticsId = '?icid=bu-ototppc-ue-cpfcmaw-0520184#';
            } else {
              analyticsId = '?icid=bu-otmbcppc-ue-cpfcmaw-0520185#';
            }
            $window.location.href = env.bfaURLs.ppc.ppcPageURL.replace('#', analyticsId);
          });
        }
      });
      // error is handled in angular7 wireless component.
    }

    function initHUP(ban, ctn) {
      return pricePlanInitiation
        .checkEligibility('hup', ctn, ban, 'UTEFidoOnline')
        .then(function(response) {
          if (
            response.data.hupErrorCode &&
            (response.data.hupErrorCode.toLowerCase() === 'error_ban_billing_address' ||
              response.data.hupErrorCode.toLowerCase() === 'ban_delinquent')
          ) {
            var className =
              response.data.hupErrorCode.toLowerCase() === 'error_ban_billing_address'
                ? 'hup-eligibility-pending-modal'
                : 'hup-eligibility-pending-modal error-highlight';
            trackAnalytics(response, response.data.hupErrorCode);
            hupErrorMessageWindow(response.data.hupErrorCode.toUpperCase(), className);
          } else if (response.data && response.data.eligible === false) {
            if (response.data.eligibilityCode.toUpperCase() === 'A') {
              trackAnalytics(response, response.data.eligibilityCode);
              hupErrorMessageWindow(
                response.data.eligibilityCode.toUpperCase(),
                'hup-eligibility-pending-modal error-highlight'
              );
            } else {
              $window._satellite.setVar('error', 'HUP | HUP eligibilty error');
              $window._satellite.track('bfa-hup-error');
              eligibilityMessageWindow(response.data.eligibilityCode);
            }
          } else {
            pricePlanInitiation.eligibilityProcessing(response.data).then(function() {
              $window.location.href = env.bfaURLs.hup.hupPageUrl;
            });
          }
        })
        .catch(handlePPCError);
    }

    function hupErrorMessageWindow(errorCode, className) {
      uteModal.open({
        templateUrl: 'modules/my-account/hup-error-modal.html',
        windowClass: className,
        controller: [
          '$scope',
          '$modalInstance',
          '$translate',
          '$state',
          function($scope, $modalInstance, $translate, $state) {
            $scope.is_hup_error = true;
            $scope.hup_errorCode = errorCode;
            $scope.hup_error_title = $translate.instant('wireless.message.' + errorCode + '_TITLE');
            $scope.hup_error_message_p1 = $translate.instant('wireless.message.' + errorCode + '_MESSAGE');
            $scope.cancel = function() {
              $modalInstance.dismiss('cancel');
            };
            $scope.redirectToPayment = function() {
              $modalInstance.dismiss('cancel');
              $state.go('myAccount.payNow');
            };
          }
        ]
      });
    }

    function ppcErrorMessageWindow() {
      uteModal.open({
        templateUrl: 'modules/my-account/ppc-pending-modal.html',
        windowClass: 'hup-eligibility-pending-modal',
        controller: [
          '$scope',
          '$modalInstance',
          '$translate',
          function($scope, $modalInstance, $translate) {
            $scope.is_ppc_error = true;
            $scope.ppc_error_title = $translate.instant('ppc_pending');
            $scope.ppc_error_message_p1 = $translate.instant('ppc_pending_desc');
            $scope.cancel = function() {
              $modalInstance.dismiss('cancel');
            };
          }
        ],
        ok: function() {},
        cancel: function() {}
      });
    }

    function eligibilityMessageWindow(errorCode) {
      uteModal.open({
        templateUrl: 'modules/my-account/embarrassing-modal.html',
        controller: [
          '$scope',
          '$modalInstance',
          '$translate',
          function($scope, $modalInstance, $translate) {
            $scope.isBfaErrorCode = true;
            $scope.bfaErrorTitle = $translate.instant('wireless.message.' + errorCode + '_TITLE');
            $scope.bfaErrorMessage = $translate.instant('wireless.message.' + errorCode + '_MESSAGE');
            $scope.cancel = function() {
              $modalInstance.dismiss('cancel');
            };
          }
        ]
      });
    }

    function trackAnalytics(response, errorCode) {
      var payload = uteDataLayerService.getConfigByMappingKey({
        mappingKey: 'advance.mappingKey.error.upgrade-my-device-error'
      });
      var api = response.config.url;
      var errorMessage = $translate.instant('wireless.message.' + errorCode.toUpperCase() + '_MESSAGE');
      var errorType = $window.ute.datalayer.common.service.ErrorType;
      var errorCategory = $window.ute.datalayer.common.service.ErrorCategory;
      var dataLayerPredefinedSection = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
      var globalObjects = [
        dataLayerPredefinedSection.ACCOUNT,
        dataLayerPredefinedSection.PAGE,
        dataLayerPredefinedSection.SITE,
        dataLayerPredefinedSection.GLOBAL
      ];
      uteDataLayerService.trackError(
        payload,
        errorType.USER,
        response.data.status,
        errorMessage,
        errorCategory.SELF_SERVE,
        '',
        api,
        true,
        globalObjects
      );
    }

    function handlePPCError(error) {
      var err;
      var displayModal = true;

      if (error instanceof Error) {
        err = error;
      } else {
        err = JSON.stringify(error, null, 2);
        displayModal = !error.suppressModal;
      }

      console.log('Error with eligibility : ', err);

      if (displayModal) {
        openEmbarrassingWindow();
      }
      return $q.reject();
    }

    function openEmbarrassingWindow() {
      uteModal.open({
        templateUrl: 'modules/my-account/embarrassing-modal.html'
      });
    }

    function openChangeCallerId() {
      uteModal.open({
        templateUrl: 'modules/my-account/wireless/change-caller-id.html',
        windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
        controller: 'changeCallerIdCtrl',
        windowClass: 'change-caller-id-specific',
        backdrop: 'static',
        size: 'lg',
        data: {
          ctnSelected: $rootScope.userInfo.selectedSubscriberNo,
          accountNumberSelected: $rootScope.userInfo.selectedAccountNumber
        }
      });
    }

    function viewPromoCode(pricePlanTitle) {
      uteModal.open({
        templateUrl: 'views/templates/modal/spotify-modal.html',
        windowTemplateUrl: 'views/templates/modal/spotify-window.html',
        windowClass: 'spotify-promo-modal-window',
        controller: [
          '$scope',
          '$modalInstance',
          'commonService',
          '$window',
          function($scope, $modalInstance, commonService, $window) {
            $window._satellite.track('vas-revolution-modal-open');
            $scope.planName = pricePlanTitle;
            $scope.spotifyError = commonService.spotifyError !== '';

            if (commonService.spotifyURL) {
              $scope.showLink = commonService.spotifyURL !== 'Code Not Assigned';
              $scope.URL = commonService.spotifyURL;
            }

            $scope.cancel = function() {
              $modalInstance.dismiss('cancel');
            };
          }
        ],
        size: commonService.spotifyModalSize,
        backdrop: true
      });
    }

    function myPlanBoxHeight(height) {
      if (!arguments.length) {
        return myPlanBoxHeightPromise;
      } else {
        myPlanBoxHeightDeferred.resolve(height);
      }
    }

    return {
      getDevice: getDevice,
      getAddon: getAddon,
      // getWProfile: getWProfile,
      getDataUsageDetails: getDataUsageDetails,
      getPlanDetails: getPlanDetails,
      getSpotifyPromoCode: getSpotifyPromoCode,
      getRlhNotification: getRlhNotification,

      openEmbarrassingWindow: openEmbarrassingWindow,
      initPPC: initPPC,
      initHUP: initHUP,
      openChangeCallerId: openChangeCallerId,
      viewPromoCode: viewPromoCode,

      myPlanBoxHeight: myPlanBoxHeight
    };
  }
})();
